export default {
	title: 'Interessengruppen',
	context_best: 'Günstig',
	context_worse: 'Feindselig',
	zones: {
		positive: 'Günstig',
		positive_line2: 'Zone',
		neutral: 'Neutral',
		negative: 'Feindselig',
		negative_line2: 'Zone',
		point_of_view_line1: 'Stand-',
		point_of_view_line2: 'punkt',
		point_of_view_line3: ''
	},
	tabs: {
		general: {
			title: 'Allgemein'
		},
		links: {
			title: 'Links'
		},
		comments: {
			title: 'Verlauf'
		},
		filters: {
			title: 'Ansichtsfilter'
		},
		export: {
			title: 'Exportieren',
			image: 'Radar als Bild exportieren'
		},
		risks: {
			title: 'Risiken'
		},
		bot: {
			title: 'KI'
		},
		tags: {
			title: 'Tags',
			assigned: 'Zugewiesene Tags',
			unassigned: 'Nicht zugewiesene Tags'
		},
		disabled: {
			title: 'Deaktiviert'
		}
	},
	summary: {
		key_drivers: 'Schlüsselfaktoren',
		scenario_score: 'Szenario-Score',
		max_value: 'max {{value}}',
		legend: {
			current: 'Aktuell',
			scenario: 'Szenario'
		}
	},
	all_tags: 'Tag-Filter',
	links: 'Alle Links anzeigen',
	no_tag: 'Kein Tag',

	all_icons: 'Symbol-Filter',
	no_icon: 'Kein Symbol',

	all_stakes: 'Interessen-Filter',
	all_constraints: 'Indikator-Filter',
	all_risks: 'Risiko-Filter',
	all_opportunities: 'Öffnungen-Filter',

	alignment: {
		title_1: 'Interessengruppen',
		title_2: 'Ausrichtung'
	},
	onboarding: {
		title: 'Interessengruppen überprüfen',
		description:
			'Die auf Ihrem Thema gewichtigen Akteure werden gemäß ihrem Einfluss und ihrer Haltung im Radar positioniert. Prüfen Sie die Ausrichtung und passen Sie an, falls Ihre Lesart abweicht.'
	}
};
